export const TEACHINGLANGUAGES = ["English", "Spanish"];
